export const TemplateStatus = {
	Draft: 0,
	Active: 1,
	Archived: 2,
} as const;

export type TemplateStatus =
	(typeof TemplateStatus)[keyof typeof TemplateStatus];

export const FORM_NAME_MAX_LENGTH = 100;
export const FORM_DESCRIPTION_MAX_LENGTH = 200;
export const SECTION_TITLE_MAX_LENGTH = 100;
export const SECTION_DESCRIPTION_MAX_LENGTH = 200;

export type TemplateSectionPayload = {
	name: string;
	description?: string | null;
	position: number;
	questions: {
		questionId: number;
		position: number;
		isRequired: boolean;
	}[];
};

export type CreateTemplatePayload = {
	name: string;
	description?: string | null;
	answerExpirationMinutes: number;
	template: {
		status: TemplateStatus;
		sections: TemplateSectionPayload[];
	};
};

export type UpdateChecklistPayload = {
	name?: string | null;
	description?: string | null;
	status: TemplateStatus;
	sections: TemplateSectionPayload[];
};

export type CreateChecklistResponse = {
	checklistId: number;
	name: string | null;
	url: string | null;
};

export type UpdateChecklistResponse = {
	checklistId: number;
	name: string | null;
	status: string | null;
	url: string | null;
};

export type ChecklistTemplate = {
	id: number;
	name: string;
	description: string | null;
	answerExpirationMinutes: number;
	createdAt: string;
	updatedAt: string | null;
};

/** Response from GET by id: template with sections and questions for preview. */
export type ChecklistTemplateDetail = Omit<
	ChecklistTemplate,
	"createdAt" | "updatedAt"
> & {
	checklistId?: number;
	status?: TemplateStatus | string | number;
	templateStatus?: string;
	checklistUrl?: string | null;
	createdAt?: string;
	updatedAt?: string | null;
	/** Sections come at the root level in the API response. */
	sections?: {
		id?: number;
		name: string;
		description?: string | null;
		position: number;
		questions?: FormViewQuestionDetail[];
	}[];
	template?: {
		sections?: ChecklistTemplateDetail["sections"];
	};
};

/** Question returned by the API for template preview. */
export type FormViewQuestionDetail = {
	id?: number;
	questionId: number;
	position: number;
	isRequired: boolean;
	prompt?: string;
	description?: string | null;
	type?: number;
	questionType?: string;
	optionDisplayType?: number | null;
	displayType?: string;
	isMultipleSelection?: boolean | null;
	options?: { id: number; label: string; position?: number }[];
};
